(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info-media-stack-desktop"] && !Shopify.designMode) return;
  try {
    if (!window.__cortailorPdpMediaToggleBound) {
    window.__cortailorPdpMediaToggleBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-pdp-media-toggle]');
      if (!button) return;

      const stackId = button.getAttribute('aria-controls');
      const stack = stackId ? document.getElementById(stackId) : null;
      if (!stack) return;

      const expanded = button.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !expanded;

      stack.classList.toggle('is-expanded', nextExpanded);
      button.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');

      const label = button.querySelector('[data-pdp-media-toggle-label]');
      if (label) {
        label.textContent = nextExpanded
          ? button.dataset.showLessLabel
          : button.dataset.showMoreLabel;
      }

      if (!nextExpanded) {
        stack
          .querySelectorAll(':scope > .pdp-desktop-media-stack__item:nth-child(n + 5) video')
          .forEach((video) => video.pause());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
